import { useRouteAccessProps } from 'hooks/business/useNewPermisson';

export const useIsOnlyMercado = () => {
  const { newPermissionMap } = useRouteAccessProps();

  const isOnlyMercado = !newPermissionMap.配置缺货提醒任务?.filter(
    ({ platform, storeCount }) => platform !== 'MERCADO' && storeCount > 0,
  )?.length;

  return isOnlyMercado;
};
